import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailDocumentDpEvent } from '../../dto/trail-document-dp-event';

@Component({
  selector: 'dpi-trail-document-dp-event-detail',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-document-dp-event-detail.component.html',
  styleUrl: './trail-document-dp-event-detail.component.scss'
})
export class TrailDocumentDpEventDetailComponent {
  readonly dialogRef = inject(MatDialogRef<TrailDocumentDpEventDetailComponent>);
  trailDocumentDpEvent: TrailDocumentDpEvent;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailDocumentDpEvent) {
    this.trailDocumentDpEvent = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }
}
